import React from 'react'
import MerchantListComponent from '../components/MerchantListComponent'

function MerchantListContainer() {
  return (
    <div>
        <MerchantListComponent/>
    </div>
  )
}

export default MerchantListContainer